// Create a new file called GoogleAnalytics.js
import { useEffect } from 'react';

export const GA_TRACKING_ID = 'G-62E2X25L6Z'; // Replace with your actual GA4 Measurement ID

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined') {
    // Add Google Analytics script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    document.head.appendChild(script1);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', GA_TRACKING_ID);
  }
};

// Track page views
export const pageview = (url) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// Track events
export const event = ({ action, category, label, value }) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// React hook for Google Analytics
export const useGoogleAnalytics = () => {
  useEffect(() => {
    initGA();
    const handleRouteChange = (url) => {
      pageview(url);
    };
    
    // Track initial page view
    handleRouteChange(window.location.pathname);
    
    return () => {
      // Cleanup if needed
    };
  }, []);
};